<template>
  <div class="mb-4 cursor-pointer" @click.prevent="$root.selectJob(`${job.job_location_id}`)">
    <div :id="`lc-job${job.job_location_id}`" class="listing-card cursor-pointer max-w-xl">
      <div v-if="!$root.isDesktopOrGreater" class="lg:hidden">
        <div
          class="relative p-6 md:py-0 md:flex md:items-center md:pl-10 md:pr-8">
          <div class="mb-4 md:mb-0 flex items-center md:py-10">
            <a :href="`companies/${job.company.slug}`" :target="`_blank`">
              <img
                  class="flex object-contain w-16 h-16 rounded-md border border-solid border-chrome-lightest lazyload"
                  :data-src="job.company.logo"
                  :alt="`${job.company.name} Logo`"
                  :title="`${job.company.name} Logo`"
              />
            </a>
            <a
              class="text-lg text-primary-darker font-medium ml-6 md:hidden hover:underline cursor-pointer capitalize"
            >
              {{ job.title }}
            </a>
          </div>
          <div v-for="(job_type, index) in job.job_types" :key="index" class="flex w-full mb-4 md:hidden">
            <vs-chip transparent :color="job_type.color ? job_type.color : slugify(job_type.name)">
              {{ job_type.name }}
            </vs-chip>
          </div>
          <div
            class="flex items-center md:flex-col md:items-start md:flex-1 md:ml-8 md:mr-2"
          >
            <a
              class="text-lg text-primary-darker font-medium hidden md:block md:mb-11px hover:underline cursor-pointer capitalize"
            >
              {{ job.title }}
            </a>
            <div class="flex w-full">
              <div
                class="text-sm text-onyx-lightest font-semibold w-1/2 md:w-auto md:max-w-1/2 mr-2 md:mr-5"
              >
                <a
                  class="flex"
                  style="color: inherit; font-size: inherit; font-weight: inherit;"
                >
                  <building-icon></building-icon>
                  <p class="ml-10px hover:underline">
                    {{ job.company.name }}
                  </p>
                </a>
              </div>
              <div
                class="text-sm text-onyx-lightest font-semibold w-1/2 md:w-auto md:max-w-1/2 ml-2 md:ml-5"
              >
                <a
                  class="flex"
                  style="color: inherit; font-size: inherit; font-weight: inherit;"
                >
                  <vs-icon
                    class="text-lg"
                    icon="icon-map-pin"
                    icon-pack="feather"
                  ></vs-icon>
                  <p class="ml-10px hover:underline">
                    {{ job.location.name }}
                  </p>
                </a>
              </div>
            </div>
          </div>

          <div v-for="(job_type, index) in job.job_types" :key="index" class="hidden md:flex">
            <vs-chip transparent :color="job_type.color ? job_type.color : slugify(job_type.name)" class="md:-mt-7">
              {{ job_type.name }}
            </vs-chip>
          </div>

          <div class="flex md:hidden">
            <a
              class="py-1 px-2 inline-flex items-center bg-primary text-white text-xs rounded-8 font-medium mt-6"
              title="View job"
            >
              <span>View job</span>
              <vs-icon
                class="ml-1"
                icon="icon-arrow-right"
                icon-pack="feather"
              ></vs-icon>
            </a>
          </div>
        </div>
      </div>
      <div v-else class="hidden lg:block">
        <div class="hidden lg:flex xl:hidden w-376px flex-col p-6">
          <div class="mb-4 flex items-center">
            <a :href="`companies/${job.company.slug}`" :target="`_blank`">
              <img
                  class="flex object-contain w-16 h-16 rounded-md border border-solid border-chrome-lightest lazyload"
                  :data-src="job.company.logo"
                  :alt="`${job.company.name} Logo`"
                  :title="`${job.company.name} Logo`"
              />
            </a>
            <div
              class="text-lg text-primary-darker font-medium ml-6 hover:underline cursor-pointer capitalize break-all"
              :title="job.title"
            >
              {{ job.title }}
            </div>
          </div>
          <div class="p-0 m-0 text-14 text-onyx-lightest font-semibold" :title="job.company.name">{{ job.company.name }}</div>

          <div class="flex items-center">
            <div class="mt-16px w-full">
              <div class="text-onyx-lightest font-normal w-full mb-8px flex items-center">
                <div class="h-22px w-22px flex justify-center items-center">
                  <vs-icon class="text-lg" icon="icon-clock" icon-pack="feather"></vs-icon>
                </div>

                <p v-for="(job_type, index) in job.job_types" :key="index" class="ml-6px text-14 text-onyx-lightest">
                  <a class="hover:underline cursor-pointer text-onyx-lightest" :href="`jobs?jt=`+job_type.id"><span>{{ job_type.name }}</span></a>
                </p>
              </div>

              <div class="text-onyx-lightest font-normal w-full flex items-center">
                <div class="h-22px w-22px flex justify-center items-center">
                  <vs-icon class="text-lg" icon="icon-map-pin" icon-pack="feather"></vs-icon>
                </div>

                <p class="ml-6px text-14 text-onyx-lightest font-normal" :title="job.location.name">{{ job.location.name }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="hidden xl:flex p-10 w-508px">
          <div class="flex">
            <a :href="`companies/${job.company.slug}`" :target="`_blank`">
              <img
                  class="flex object-contain w-16 h-16 rounded-md border border-solid border-chrome-lightest lazyload"
                  :data-src="job.company.logo"
                  :alt="`${job.company.name} Logo`"
                  :title="`${job.company.name} Logo`"
              />
            </a>
          </div>
          <div class="flex flex-col ml-8 flex-1">
            <div
              class="text-lg text-primary-darker font-medium my-2 hover:underline cursor-pointer capitalize break-all"
              :title="job.title"
            >
              {{ job.title }}
            </div>

            <div class="p-0 m-0 text-14 text-onyx-lightest font-semibold" :title="job.company.name">{{ job.company.name }}</div>

            <div class="mt-16px w-full">
              <div class="text-onyx-lightest font-normal w-full mb-8px flex items-center">
                <div class="h-22px w-22px flex justify-center items-center">
                  <vs-icon class="text-lg" icon="icon-clock" icon-pack="feather"></vs-icon>
                </div>

                <p v-for="(job_type, index) in job.job_types" :key="index" class="ml-6px text-14 text-onyx-lightest">
                  <a class="hover:underline cursor-pointer text-onyx-lightest" :href="`jobs?jt=`+job_type.id">
                    <span :title="job_type.name">{{ job_type.name }}</span>
                  </a>
                </p>
              </div>

              <div class="text-onyx-lightest font-normal w-full flex items-center">
                <div class="h-22px w-22px flex justify-center items-center">
                  <vs-icon class="text-lg" icon="icon-map-pin" icon-pack="feather"></vs-icon>
                </div>

                <p class="ml-6px text-14 text-onyx-lightest font-normal" :title="job.location.name">{{ job.location.name }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { slugify } from '../../utilities/slugify';
import CCRequestInputMixin from "../../mixins/CCRequestInputMixin";
import QueryParameters from "../../utilities/queryparameters";

export default {
  mixins: [CCRequestInputMixin],
  props: {
    job: {
      type: Object,
      required: true,
    },
    jobRoute: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
        QueryParameters: QueryParameters
    }
  },

  computed: {
    companyRoute() {
      return this.addCCToRoute(`/companies/${this.job.company.slug}`);
    },
    fullJobRoute() {
      return `${this.jobRoute.replace(/primary_location=/, `primary_location=${this.job.location.name}`)}`;
    }
  },

  methods: {
    slugify(str) {
      return slugify(str);
    },
  },

  mounted() {
    const moreJobsButton = this.$root.$refs.moreJobsButton;
    
    if (moreJobsButton) {
      const totalJobsFound = parseInt(this.$root.$refs.totalJobsFound.innerText);
      const jobsPerPage = parseInt(this.$root.$refs.jobsPerPage.innerText);
      const totalJobsReturned =
        parseInt(this.$root.$refs.jobsPerPage.innerText) *
        (this.$root.nextPageNumber - 1);
      const totalJobsRemaining = totalJobsFound - totalJobsReturned;

      moreJobsButton.innerText =
        totalJobsRemaining > jobsPerPage ? jobsPerPage : totalJobsRemaining;
    }
  }
};
</script>
